import { Routes } from '@angular/router';
import { PaymentComponent } from '../../components/payment/payment.component';
import { depositTrx, paymentApayTrx, withdrawalTrx } from '../../router-translation.labels';
import { MainDepositComponent } from '../../components/payment/deposit/main-deposit/main-deposit.component';
import { WithdrawalComponent } from '../../components/payment/withdrawal/withdrawal.component';
import { loginTrx } from 'src/app/router-translation.labels';
import { LoginDialogRouteComponent } from 'src/app/components/auth/login-dialog/login-dialog.component';

const loginRoute = {
  path: loginTrx,
  component: LoginDialogRouteComponent
};

export const PAYMENT_MODULE_ROUTES_NOT_TRANSLATED: Routes = [
  {
    path: '',
    component: PaymentComponent,
    children: [
      {
        path: depositTrx,
        component: MainDepositComponent,
        children: [
          { path: paymentApayTrx, loadChildren: () => import('../../components/payment/deposit/custom-payment-flows/apay.module').then(m => m.ApayModule) }

        ]
      },
      {
        path: withdrawalTrx,
        component: WithdrawalComponent
      },
      {
        path: 'wplata',
        component: MainDepositComponent,
        children: [
          { path: paymentApayTrx, loadChildren: () => import('../../components/payment/deposit/custom-payment-flows/apay.module').then(m => m.ApayModule) }

        ]
      },
      {
        path: 'wyplata',
        component: WithdrawalComponent
      },
      loginRoute,
    ]
  }
];
